<template>
    <v-card flat xs12>
      <v-toolbar>
        <v-toolbar-title>
          <v-icon :color="iconColor">{{ icon }}</v-icon>
          <span class="ml-1">{{ title }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span  class="d-flex justify-center">
            <v-toolbar-items>
              <span v-if="editing">
                <v-icon :color="editingIconColor">edit</v-icon>
              </span>
              <app-login-av :auth="auth"></app-login-av>
            </v-toolbar-items>
        </span>
      </v-toolbar>
      <v-card-text v-if="$apollo.loading">
        <v-progress-linear v-if="!$apollo.loading" :indeterminate="true" color="accent" :active="true"></v-progress-linear>
      </v-card-text>
    </v-card>
</template>
<script>
import { SearchUtils } from '@/js'
import { getIcon, getIconColor } from '@/js/store'
import Loginav from '@/components/Loginav'
export default {
  props: {
    itemReason: Object,
    rowType: String,
    editing: String,
    auth: Object
  },
  components: {
    'app-login-av': Loginav
  },
  computed: {
    icon () {
      return getIcon(this.rowType)
    },
    iconColor () {
      return getIconColor(this.rowType)
    },
    editingIconColor () {
      return getIconColor(this.editing)
    },
    title () {
      return SearchUtils.getTextFromReason({ reason: this.itemReason, rowType: this.rowType })
    }
  },
  name: 'Bigtitle'
}
</script>
